import { useState } from "react"

import { formatPhoneNumberInput } from "../utils/formatters"

type InitConfig = {
  isPhoneNumberInput: boolean
}

export const useContactSearchInput = (config?: InitConfig) => {
  const [contactQuery, setContactQuery] = useState("")
  const [isPhoneNumberInput, setIsPhoneNumberInput] = useState(
    config?.isPhoneNumberInput || false,
  )

  const onContactQueryChange = (input: string) => {
    if (config?.isPhoneNumberInput) {
      setContactQuery(formatPhoneNumberInput(input))
      return
    }

    if (input === "+7 ") {
      setIsPhoneNumberInput(false)
    }

    if (input.length === 1) {
      const isNumber = !Number.isNaN(parseFloat(input))

      if (isNumber) {
        setIsPhoneNumberInput(true)
        setContactQuery(formatPhoneNumberInput(input))
      } else {
        setContactQuery(input)
      }
    } else {
      setContactQuery(
        isPhoneNumberInput ? formatPhoneNumberInput(input) : input,
      )
    }
  }

  return {
    contactQuery,
    onContactQueryChange,
  }
}
